<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <Breadcrumb routeName="HomeInlet" toName="添加新内容" goPathName="首页快捷入口"></Breadcrumb>
      <a-form-model ref="form" :model="ruleForm" :rules="rules" :label-col="{span:4}" :wrapper-col="{span:20}"
                    style="max-width: 1000px">
        <a-form-model-item label="内容类型" prop="iconType">
          <a-radio-group v-model="ruleForm.iconType">
            <a-radio :value="1">商品</a-radio>
            <a-radio :value="2">链接</a-radio>
            <a-radio :value="4">小程序</a-radio>
            <a-radio :value="5">主题/子类目</a-radio>
            <a-radio :value="6">微信视频号</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="图标" required prop="iconImg">
          <custom-upload-pro-images
            v-model="ruleForm.iconImg"
            :multiple-selected="false"
            :showFlag="false"
            :maxCount="1"
            tips="温馨提示：图片上传尺寸为 120*120 上传图片格式为.jpg、.png、.jpeg"
            :draggableUpdate="false"></custom-upload-pro-images>
        </a-form-model-item>
        <a-form-model-item label="标题" prop="iconName">
          <a-input
            v-model="ruleForm.iconName"
            placeholder="请输入"
            style="max-width:500px"
            :maxLength="99"
          />
        </a-form-model-item>
        <a-form-model-item label="副标题" prop="iconSubTitle">
          <a-input
            v-model="ruleForm.iconSubTitle"
            placeholder="请输入"
            style="max-width:500px"
            :maxLength="99"
          />
        </a-form-model-item>
        <a-form-model-item label="关联商品" v-if="ruleForm.iconType===1">
          <a-form-model-item
            style="margin-bottom: 0;display: inline-block"
            prop="iconIsProductGroup">
            <a-select
              v-model="ruleForm.iconIsProductGroup"
              style="width:140px;margin-right: 20px"
              placeholder="请选择">
              <a-select-option :value="0">关联单个商品</a-select-option>
              <a-select-option :value="1">关联商品分组</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            style="margin-bottom: 0;display: inline-block;margin-left: 20px"
            :validate-status="ruleForm.iconLinked?'success':'error'"
            :help="ruleForm.iconLinked?'':'请关联产品或产品分组'"
          >
            <a-button @click="showModel">选择</a-button>
            <span
              v-if="ruleForm.iconLinked">&nbsp;&nbsp;{{ ruleForm.iconIsProductGroup == 1 ? '商品组ID' : '商品ID' }}：{{ ruleForm.iconLinked }}</span>
          </a-form-model-item>
        </a-form-model-item>
        <div v-if="ruleForm.iconType===2">
          <a-form-model-item label="链接" prop="interlinkage">
            <a-input
              v-model="ruleForm.interlinkage"
              placeholder="小程序仅支持安全域名下的链接"
              style="max-width:500px"
            />
          </a-form-model-item>
        </div>
        <div v-if="ruleForm.iconType===4">
          <a-form-model-item label="appId" prop="iconAppletAppId">
            <a-input
              v-model="ruleForm.iconAppletAppId"
              placeholder="小程序appId"
              style="max-width:500px"
            />
          </a-form-model-item>
          <a-form-model-item label="跳转路径" prop="iconAppletAppUrl">
            <a-input
              v-model="ruleForm.iconAppletAppUrl"
              placeholder="小程序页面路径"
              style="max-width:500px"
            />
          </a-form-model-item>
        </div>
        <div v-if="ruleForm.iconType===5">
          <a-form-model-item label="关联主题/子类目" prop="categoryTheme">
            <a-cascader
              style="width:300px;"
              :allowClear="true"
              :field-names="{ label: 'name', value: 'id',children:'children'}"
              :options="themeList"
              placeholder="请选择"
              change-on-select
              v-model="ruleForm.categoryTheme"
            />
          </a-form-model-item>
        </div>

        <div v-if="ruleForm.iconType===5 && isMerchandiseType">
          <a-form-model-item label="百货类型">
            <a-radio-group name="radioGroup" :disabled="!isCloseMerchandise" v-model="ruleForm.commodityType">
              <a-radio :value="0">全部</a-radio>
              <a-radio :value="1">普通商品</a-radio>
              <a-radio :value="2">跨境商品</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </div>
        <div v-if="ruleForm.iconType===5 && isMerchandiseType&& ruleForm.categoryTheme.length>1">
          <a-form-model-item label="频道设置">
            <a-button type="primary" @click="showChannelDialog">设置</a-button>
          </a-form-model-item>
        </div>
        <div v-if="ruleForm.iconType===6">
          <a-form-model-item label="视频号ID" prop="wechatVideoId">
            <a-input v-model="ruleForm.wechatVideoId" placeholder="请输入视频号ID" style="max-width:500px"/>
          </a-form-model-item>
        </div>
        <a-form-model-item label=" " :colon="false" :required="false">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <!-- 商品组件弹窗 -->
    <ProductPopupView :visible="visiblePopup" @change="changeSelectPro" @cancel="handleCancel"></ProductPopupView>
    <selected-product-dialog
      ref="groupDialog"
      :col="2"
      :show="showSelectedGroupDialog"
      :itemNames="['search_proName']"
      :query-params="selectedQueryGroupParams"
      :request-promise="getGroupRequest"
      @close="showSelectedGroupDialog=false"
      :columns="getGroupColumns()"
    >
      <a-form-item
        label="商品分组名称"
        slot="search_proName"
        :wrapperCol="{span:18}"
        :labelCol="{span:6}">
        <a-input
          v-model="selectedQueryGroupParams.groupName"
          style="width: 100%"
          placeholder="请输入商品分组名称"
        ></a-input>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedGroupResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
    <!-- 频道设置弹窗 -->
    <ChannelSettingsDialog
      v-if="channelVisible"
      :iconId="iconId"
      :crossBorderDirect="ruleForm.commodityType"
      :type="ruleForm.categoryTheme&&ruleForm.categoryTheme.length>1&&ruleForm.categoryTheme[1]"
      :visible="channelVisible"
      @onDraggableChange="onDraggableChange"
      @onRadioChange="onRadioChange"
      @cancel="closeChannelDialog"
      :channelStatus1="this.commodityTypeChannelSet[0].status"
      :channelStatus2="this.commodityTypeChannelSet[1].status"
    ></ChannelSettingsDialog>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import ProductPopupView from '@/customComponents/productPopupView/productPopupView'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'
import ChannelSettingsDialog from '@/views/platform/component/ChannelSettingsDialog'

import { getQueryString } from '@/utils/common.js'

export default {
  name: 'AddInletContent',
  components: {
    Breadcrumb,
    ProductPopupView,
    SelectedProductDialog,
    CustomUploadProImages,
    ChannelSettingsDialog
  },
  data() {
    var checkCategoryTheme = (rule, value, callback) => {
      // setTimeout(() => {
      if (value && value.length < 2) {
        callback(new Error('请选择二级数据'))
      } else {
        callback()
      }
      // }, 1000);
    }
    var checkIconSubTitle = (rule, value, callback) => {
      if (/[^\u4e00-\u9fa5a-zA-Z]/g.test(value)) {
        callback(new Error('请输入中英文'))
      } else {
        callback()
      }
    }
    return {
      type: 1,
      visiblePopup: false,
      submitLoading: false,
      showSelectedGroupDialog: false,
      iconId: this.$route.query.iconId,
      fileList: [],
      imageUrl: '',
      proId: '',
      iconIsProductGroup: 0,
      selectedQueryGroupParams: { groupStatus: 1 },
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      showCount: 0,
      ruleForm: {
        iconType: 1,
        interlinkage: '',
        categoryTheme: [],
        commodityType: 0,
        wechatVideoId: ''
      },
      rules: {
        iconType: [
          { required: true, message: '请选择内容类型', trigger: ['blur', 'change'] }
        ],
        iconImg: [
          { required: true, message: '请上传图标', trigger: ['blur', 'change'] }
        ],
        iconName: [
          { required: true, message: '请输入标题', trigger: ['blur', 'change'] }
        ],
        iconIsProductGroup: [
          { required: true, message: '请选择关联类型', trigger: ['blur', 'change'] }
        ],
        // iconLinked: [
        //   { required: true, message: '请关联产品或产品分组', trigger: ['blur', 'change'] }
        // ],
        interlinkage: [
          { required: true, message: '请输入链接', trigger: ['blur', 'change'] },
          { pattern: /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/, message: '请输入正确网络链接' }
        ],
        iconAppletAppId: [
          { required: true, message: '请输入小程序appId', trigger: ['blur', 'change'] }
        ],
        iconAppletAppUrl: [
          { required: true, message: '请输入小程序页面路径', trigger: ['blur', 'change'] }
        ],
        categoryTheme: [
          { required: true, message: '请选择主题/子类目', trigger: ['blur', 'change'] },
          { validator: checkCategoryTheme, trigger: ['blur', 'change'] }
        ],
        iconSubTitle: [
          { validator: checkIconSubTitle, trigger: ['blur', 'change'] }
        ],
        wechatVideoId: [
          { required: true, message: '请输入视频号ID', trigger: ['blur', 'change'] }
        ]
      },
      initFinish: false,
      themeList: [],
      isCloseMerchandise: false, //跨境直连设置:0=关闭 1=芥舟科技
      merchantId: this.$store.getters.userInfo.merchantId,
      channelVisible: false,
      commodityTypeChannelSet: [
        {
          channelType: 1,
          status: 2,
          idList: [],
          pageNum: 1,
          pageSize: 10
        },
        {
          channelType: 2,
          status: 2,
          idList: [],
          pageNum: 1,
          pageSize: 10
        }
      ]
    }
  },
  watch: {
    'ruleForm.iconIsProductGroup': function(newVal, oldVal) {
      if (this.initFinish) {
        this.ruleForm.iconLinked = undefined
      }
    },
    'ruleForm.iconType': function(newVal, oldVal) {
      if (this.initFinish) {
        this.$nextTick(() => {
          this.ruleForm.iconLinked = undefined
          this.ruleForm.interlinkage = undefined
          this.ruleForm.iconIsProductGroup = 0
        })
      }
    }
  },
  computed: {
    isMerchandiseType() { //判断是都选择了百货
      if (this.ruleForm.categoryTheme && this.ruleForm.categoryTheme.length) {
        if (this.ruleForm.categoryTheme[0] == 5) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  mounted() {
    if (this.iconId != 0) {
      this.getHomeIconDetail()
    } else {
      this.initFinish = true
    }
    this.getThemeList()
    this.getCloseMerchandise()
  },

  methods: {
    onDraggableChange(value) {
      console.error('onDraggableChange', value)
      if (value.type == 1) {
        this.commodityTypeChannelSet[0].idList = value.idList
        this.commodityTypeChannelSet[0].pageNum = value.pageNum
        this.commodityTypeChannelSet[0].pageSize = value.pageSize
      } else {
        this.commodityTypeChannelSet[1].idList = value.idList
        this.commodityTypeChannelSet[1].pageNum = value.pageNum
        this.commodityTypeChannelSet[1].pageSize = value.pageSize
      }
    },
    onRadioChange(value) {
      if (this.iconId == 0 || this.iconId == '0') {
        if (value.channelType == 1) {
          this.commodityTypeChannelSet[0].status = value.status
        } else {
          this.commodityTypeChannelSet[1].status = value.status
        }
      } else {
        let params = {
          iconId: this.iconId,
          status: value.status,
          channelType: value.channelType
        }
        let title = value.status ? '开启' : '关闭'
        this.getHttpServices().getUserService().post('homepage/icon/save/commodityTypeChannelSet', params)
          .then(res => {
            this.$message.success(title + '成功')
            if (value.channelType == 1) {
              this.commodityTypeChannelSet[0].status = value.status
            } else {
              this.commodityTypeChannelSet[1].status = value.status
            }
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    },
    showChannelDialog() {
      this.channelVisible = true
    },
    closeChannelDialog() {
      this.channelVisible = false
    },
    getCloseMerchandise() { //查询运营商是否开通跨境设置
      this.getHttpServices().getUserService().post('user/merchantInfo/queryMerchantCrossBorderDirectOpen', {
        merchantId: this.merchantId
      }).then(res => {
        this.isCloseMerchandise = res.crossBorderDirect == 1 ? true : false
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    showModel() {
      if (this.ruleForm.iconIsProductGroup < 1) {
        this.visiblePopup = true
      } else {
        this.selectedQueryGroupParams = { groupStatus: 1 }
        this.showSelectedGroupDialog = true
        if (this.showCount > 0) {
          this.$nextTick(() => this.$refs.groupDialog.refresh(true))
        }
        this.showCount++
      }
    },
    onChange(e) {
      this.getLogUtils().logWithTag('radio checked', e.target.value)
      this.type = e.target.value
    },
    // 主题/子类目-查询
    getThemeList() {
      Promise.all([this.getAllThemeList(), this.getMerchantNewField()])
        .then(list => {
          if (list[0] && list[0].length && list[1].productCatalogList && list[1].productCatalogList.length) {
            list[1].productCatalogList.forEach(v => {
              list[0].forEach(item => {
                if (item.id === v) this.themeList.push(item)
              })
            })
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getAllThemeList() {
      const url = 'homepage/icon/find/theme'
      return this.getHttpServices().getUserService().get(url)
    },
    getMerchantNewField() {
      const url = `homeMerchant/getMerchantNewField/${this.$store.getters.userInfo.merchantId}`
      return this.getHttpServices().getApiService().post(url)
    },
    // 获取详情数据
    getHomeIconDetail() {
      this.getHttpServices().getUserService().post('homepage/icon/get/iconDetail', {
        iconId: this.iconId
      }).then(res => {
        this.ruleForm = {
          ...res,
          interlinkage: res.iconType == 2 ? res.iconLinked : undefined,
          iconImg: res.iconImg ? [res.iconImg] : [],
          categoryTheme: res.categoryTheme ? res.categoryTheme.split('/').map(Number) : []
        }
        if (this.ruleForm.iconType === 5 && this.isMerchandiseType && this.ruleForm.categoryTheme.length > 1) {
          this.getCommodityTypeChannelSet()
        }
        if (!this.isCloseMerchandise) {
          this.ruleForm.commodityType = 0 //百货类型
        }
        console.error('this.ruleForm', this.ruleForm)
        this.$nextTick(() => this.initFinish = true)
        this.getLogUtils().logWithTag('==getHomeIconDetail==', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getCommodityTypeChannelSet() {
      let params = {
        iconId: this.iconId
      }
      this.getHttpServices().getUserService().post('/homepage/icon/get/commodityTypeChannelSet', params)
        .then(res => {
          if (res && res.length) {
            res.forEach(item => {
              if (item.channelType == 1) {
                this.commodityTypeChannelSet[0].status = item.status
              } else {
                this.commodityTypeChannelSet[1].status = item.status
              }
            })
          }
          // this.commodityTypeChannelSet[0].status  =  res[0].status;
          // this.commodityTypeChannelSet[1].status  =  res[1].status;
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 保存表单数据
    handleSubmit(e) {
      this.getLogUtils().logWithTag('=======handleSubmit=====', this.ruleForm)
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.ruleForm.iconType == 1 && !this.ruleForm.iconLinked) {
            const tips = this.ruleForm.iconIsProductGroup == 1 ? '请选择关联商品分组' : '请选择关联商品'
            this.$message.error(tips)
            return
          }
          console.error('=====this.ruleForm====', this.ruleForm)
          if (this.ruleForm.iconType == 2 && !this.ruleForm.interlinkage) {
            const tips = '请选输入商品链接'
            this.$message.error(tips)
            return
          }
          this.getLogUtils().logWithTag('=======handleSubmit=====', this.ruleForm)
          let params = {
            ...this.ruleForm,
            iconImg: this.ruleForm.iconImg && this.ruleForm.iconImg.length > 0 ? this.ruleForm.iconImg[0] : '',
            interlinkage: undefined
          }
          if (this.iconId == 0 && this.ruleForm.iconType === 5 && this.isMerchandiseType && this.ruleForm.categoryTheme.length > 1) {
            params.commodityTypeChannelSet = this.commodityTypeChannelSet
          } else {
            params.commodityTypeChannelSet = []
          }
          params.iconLinked = this.ruleForm.interlinkage && this.ruleForm.iconType === 2 ? this.ruleForm.interlinkage : this.ruleForm.iconLinked
          params.iconParamLinked = null
          params.iconParamLinkedType = null
          if (this.ruleForm.iconType === 5) {
            params.categoryTheme = this.ruleForm.categoryTheme.join('/')
            params.categoryProductType = this.ruleForm.categoryTheme[0]
          } else {
            params.categoryTheme = null
          }
          if (this.ruleForm.interlinkage) {
            let url = new URL(this.ruleForm.interlinkage)
            if (getQueryString('subjectMerchantId', url) != null) {
              params.iconParamLinked = getQueryString('subjectMerchantId', url)
              params.iconParamLinkedType = 2
            } else if (getQueryString('proId', url) != null) {
              params.iconParamLinked = getQueryString('proId', url)
              params.iconParamLinkedType = 1
            }
          }
          this.getLogUtils().logWithTag('保存表单数据', params)
          this.submitLoading = true
          console.error('params', params)
          this.getHttpServices().getUserService().post('homepage/icon/save/iconDetail', params)
            .then(res => {
              this.getLogUtils().logWithTag('==handleSubmit==', res)
              this.$message.success('内容保存成功')
              this.$router.push({
                name: 'HomeInlet'
              })
            }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
        } else {
          this.$message.error('请完善表单信息')
        }
      })
    },

    // 选择商品
    changeSelectPro(item) {
      this.getLogUtils().logWithTag('选择商品', item)
      this.ruleForm.iconLinked = item.proId
      this.handleCancel()
    },
    handleCancel() {
      this.visiblePopup = false
    },
    onSelectedGroupResult(item) {
      this.ruleForm.iconLinked = item.groupId
      this.showSelectedGroupDialog = false
    },
    getGroupRequest(params) {
      return this.getHttpServices().getProService().post('/proGroup/findProGroupList', params)
    },
    getGroupColumns() {
      return [
        {
          title: 'id',
          dataIndex: 'groupId',
          width: '60px'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }

  }

}
</script>
<style lang="less">
@import url('../../CustomPage.less');

.heading {
  font-size: 20px;
  font-weight: 400;
  color: #000;
}

.pl10 {
  padding-left: 10px;
}
</style>